var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-header"},[_c('img',{attrs:{"src":_vm.icon,"height":"50px","width":"50px"},on:{"click":_vm.goHome}}),_c('h3',{on:{"click":_vm.goHome}},[_vm._v("怀真 CMS")])])
}
var staticRenderFns = []

export { render, staticRenderFns }